import { buildBindable } from '@monofe/di';
import { bindConfigManifest, injectConfigManifest, TYPES, unbindConfigManifest } from '@monofe/util';
import MANIFEST_JSON from '../../../public/manifest.json';

function _build(container) {
  return Promise.resolve(Object.freeze(MANIFEST_JSON));
}

export default buildBindable({
  id: TYPES.IConfigManifest,
  dependencies: [],
  bind: bindConfigManifest,
  remove: unbindConfigManifest,
  inject: injectConfigManifest,
  build: container => Promise.resolve(_build(container))
});